export const isIOS = () => navigator.userAgent.match(/(iPhone|iPod|iPad)/i);

export const isHarmony = () => navigator.userAgent.match(/(OpenHarmony)/i);

export const isIphoneX = () => {
  try {
    if (isIOS()) {
      // 是iphoneX 或iphoneX max, 判断iphone宽度目前感觉有点问题
      if (window.screen.height >= 812) {
        return true;
      }
      return false;
    }
  } catch (error) {
    console.log(error);
  }
  return false;
};
